import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import { TOAST_STATE } from "../core/constants";
import { getDomainCfg, store } from "../core/state";
import { getComponentData, setComponentData } from "../core/views";
import { translate } from "../core/i18n";
import { useEffect, useRef } from "react";

export const showToast = (title: string, message: string): void => {
  const successImg = getDomainCfg().product.successImg;
  const toastState = getComponentData(TOAST_STATE);
  toastState.data = {
    show: true,
    title,
    message,
    img: successImg
  }
  setComponentData(TOAST_STATE, toastState);  
}

export const InfoToast = () => {
  const [toastState, setToastState] = store.useState(TOAST_STATE);

  useEffect(() => {
    if (toastState?.data?.show) {
      
      setTimeout(() => {
        closeToast();
      }, 5000);
    }
  }, [toastState]);

  const closeToast = () => {
    console.log("close toast");
    const newData = {
      ...toastState.data,
      show: false
    };
    setToastState(newData);
  }

  const show = toastState?.data?.show || false;
  console.log("toastState", toastState, show);

  const hasImg = toastState?.data?.img ? true : false;
  const toastImage = hasImg ? "<div class='text-center'><span class='color-change'><img class='tadaEffectProjectSuccess' src='" + toastState?.data?.img + "'></span></div>" : "";

  return (<>    
    <ToastContainer className={show ? "p-3" : ""} position={'bottom-center'} style={{ zIndex: 90000 }} >
      <Toast show={show} delay={500} onClose={closeToast}>
        <Toast.Header>
          <strong className="me-auto">{translate("achievement-unlocked")}</strong>
        </Toast.Header>
        <Row>
          {hasImg &&
            <Col xs={2} className="toast-image-container">
              <div dangerouslySetInnerHTML={{ __html: toastImage }} />
            </Col>
          }
          <Col xs={10}>
            <b>{toastState?.data?.title}</b><br />
            {toastState?.data?.message}
          </Col>
        </Row>
      </Toast>
    </ToastContainer>
  </>
  );
}
